import { createContext, use, useEffect } from "react";

export interface LayoutInsetControls {
  setFullBleed: (fullBleed: boolean) => void;
}

export const LayoutInsetContext = createContext<LayoutInsetControls | null>(null);

/** Removes the sidebar layout's content inset while the calling page is mounted. */
export function useFullBleedLayout(): void {
  const controls = use(LayoutInsetContext);
  useEffect(() => {
    if (!controls) return;
    controls.setFullBleed(true);
    return () => controls.setFullBleed(false);
  }, [controls]);
}
